<template>
  <main class="blog-page">
    <div class="blog-wrapper">
      <div class="f fc gap12">
        <UiBreadCrumbsV2
          :items="breadcrumbs"
          class="blog-page-breadcrumbs"
        />

        <nuxt-link
          v-if="globalStore.user?.is_admin"
          :to="localePath(`/blog/moderation/edit/${article?.data?.getBlogPost?.category?.link}/${article?.data?.getBlogPost?.link}`)"
          class="mb16 btn btn-primary f gap8"
        >
          <svg
            height="12"
            width="12"
          >
            <use xlink:href="/icons/sprite.svg#i-edit" />
          </svg>
          {{ t('edit') }}
        </nuxt-link>
      </div>

      <div>
        <!--        <div class="blog-wrapper-small"> -->
        <div class="f fs faic gap16 mb24 w-100">
          <span
            v-if="article?.data?.getBlogPost?.is_main"
            class="top"
          ><i class="i-fire mr2" /> TOP </span>
          <p
            :style="{ color: article?.data?.getBlogPost?.category?.color }"
            class="colored-title"
          >
            {{ article?.data?.getBlogPost?.category?.title }}
          </p>

          <UiThemeSwitcher class="mla" />
        </div>
        <h1>
          {{ article?.data?.getBlogPost?.title }}
        </h1>
        <p class="mb24 lh2 f18">
          {{ article?.data?.getBlogPost?.description }}
        </p>

        <div class="f read-info">
          <svg>
            <use xlink:href="/icons/sprite.svg#clock" />
          </svg>
          <span class="f14">{{
            $t('read_time', { time: article?.data?.getBlogPost?.read_time })
          }}</span>
        </div>
        <img
          :alt="article?.data?.getBlogPost?.title"
          :src="getImageFromProxy(article?.data?.getBlogPost?.img || '', '1200:1000', true)"
          class="main-img"
          loading="eager"
        >

        <section class="content">
          <div
            v-if="content"
            class="mb32"
            v-html="content"
          />

          <div class="hr" />

          <div class="f mt24 flex-wrap">
            <div class="f gap8">
              <!--                <span :style="{color: currentCategory?.color}" class="colored-title mb0"> -->
              <!--                  {{ currentCategory?.title }} -->
              <!--                </span> -->

              <div class="author f faic">
                <div v-tooltip="article?.data?.getBlogPost?.author?.persona_name">
                  <img
                    :src="getImageFromProxy(article?.data?.getBlogPost?.author?.avatar_url || '', '100:100')"
                    alt="author image"
                    class="author-image"
                  >
                </div>
                <div class="author-info">
                  <p class="fw600 white">
                    {{ article?.data?.getBlogPost?.author?.persona_name }}
                  </p>
                  <p class="mb0">
                    {{ moment(article?.data?.getBlogPost?.published_at).format('DD MMMM, YYYY') }}
                  </p>
                  <!--                  <div class="f gap4"> -->
                  <!--                    <svg height="16" width="16"> -->
                  <!--                      <use xlink:href="/icons/sprite.svg#i-eye"></use> -->
                  <!--                    </svg> -->
                  <!--                    <span class="f14"> -->
                  <!--                      {{ -->
                  <!--                        $t('views_count', {count: article?.data?.getBlogPost?.views}) -->
                  <!--                      }} -->
                  <!--                    </span> -->
                  <!--                  </div> -->
                </div>
              </div>
            </div>

            <PagesBlogLikeAndShareBtns
              :likes-count="+(article?.data?.getBlogPost?.likes_count || 0)"
              :user-liked="article?.data?.getBlogPost?.liked"
              @on-liked="likePost"
            />
          </div>
        </section>
      </div>

      <!--        <aside class="blog-sidebar"> -->
      <!--          <div class="author f fs mb24"> -->
      <!--            <div v-tooltip="article?.data?.getBlogPost?.author?.persona_name"> -->
      <!--              <img -->
      <!--                  :src="getImageFromProxy(article?.data?.getBlogPost?.author?.avatar_url || '', '100:100')" -->
      <!--                  alt="author image" -->
      <!--                  class="author-image" -->
      <!--              > -->
      <!--            </div> -->
      <!--            <div class="author-info"> -->
      <!--              <p class="fw600 white mb0"> -->
      <!--                {{ article?.data?.getBlogPost?.author?.persona_name }} -->
      <!--              </p> -->
      <!--              <p class="mb0"> -->
      <!--                {{ moment(article?.data?.getBlogPost?.published_at).format('DD MMMM, YYYY') }} -->
      <!--              </p> -->
      <!--            </div> -->
      <!--          </div> -->

      <!--          <PagesBlogLikeAndShareBtns -->
      <!--              :likes-count="+(article?.data?.getBlogPost?.likes_count || 0)" -->
      <!--              :user-liked="article?.data?.getBlogPost?.liked" -->
      <!--              class="mb32" -->
      <!--              @on-liked="likePost" -->
      <!--          /> -->

      <!--          <div v-if="latestArticles?.length"> -->
      <!--            <p class="title-h3 f18 mb20"> -->
      <!--              {{ $t('latest_articles') }} -->
      <!--            </p> -->
      <!--            <PagesBlogSidebarArticlesList :articles="latestArticles" /> -->
      <!--            &lt;!&ndash;            <div&ndash;&gt; -->
      <!--            &lt;!&ndash;                class="articles-list"&ndash;&gt; -->
      <!--            &lt;!&ndash;            >&ndash;&gt; -->
      <!--            &lt;!&ndash;              <div v-for="latestArticle in latestArticles" :key="latestArticle.link"&ndash;&gt; -->
      <!--            &lt;!&ndash;                   class="articles-list-item ">&ndash;&gt; -->
      <!--            &lt;!&ndash;                <nuxt-link&ndash;&gt; -->
      <!--            &lt;!&ndash;                    :to="localePath(`/blog/${latestArticle?.category?.link}/${latestArticle?.link}`)"&ndash;&gt; -->
      <!--            &lt;!&ndash;                    class="articles-list-item-link"></nuxt-link>&ndash;&gt; -->
      <!--            &lt;!&ndash;                <p :style="{color: latestArticle?.category?.color}"&ndash;&gt; -->
      <!--            &lt;!&ndash;                   class="category colored-title f14 mb0">&ndash;&gt; -->
      <!--            &lt;!&ndash;                  {{ latestArticle?.category?.title }}&ndash;&gt; -->
      <!--            &lt;!&ndash;                </p>&ndash;&gt; -->
      <!--            &lt;!&ndash;                <p class="title-h3">&ndash;&gt; -->
      <!--            &lt;!&ndash;                  {{ latestArticle?.title }}&ndash;&gt; -->
      <!--            &lt;!&ndash;                </p>&ndash;&gt; -->
      <!--            &lt;!&ndash;                <div class="f mta">&ndash;&gt; -->
      <!--            &lt;!&ndash;                  <div v-tooltip="latestArticle?.author?.persona_name">&ndash;&gt; -->
      <!--            &lt;!&ndash;                    <img&ndash;&gt; -->
      <!--            &lt;!&ndash;                        :src="getImageFromProxy(latestArticle?.author?.avatar_url || '', '30:30')"&ndash;&gt; -->
      <!--            &lt;!&ndash;                        alt="moderator avatar"&ndash;&gt; -->
      <!--            &lt;!&ndash;                        class="avatar"&ndash;&gt; -->
      <!--            &lt;!&ndash;                    >&ndash;&gt; -->
      <!--            &lt;!&ndash;                  </div>&ndash;&gt; -->
      <!--            &lt;!&ndash;                  <span class="f14">&ndash;&gt; -->
      <!--            &lt;!&ndash;                    {{ $t('read_time', {time: latestArticle?.read_time}) }}&ndash;&gt; -->
      <!--            &lt;!&ndash;                  </span>&ndash;&gt; -->
      <!--            &lt;!&ndash;                </div>&ndash;&gt; -->
      <!--            &lt;!&ndash;              </div>&ndash;&gt; -->
      <!--            &lt;!&ndash;            </div>&ndash;&gt; -->
      <!--          </div> -->
      <!--          <div v-if="viewedArticles?.length" class="mt24"> -->
      <!--            <p class="title-h3 f18 mb20"> -->
      <!--              {{ $t('you_viewed') }} -->
      <!--            </p> -->

      <!--            <PagesBlogSidebarArticlesList :articles="viewedArticles" /> -->
      <!--            &lt;!&ndash;            <div&ndash;&gt; -->
      <!--            &lt;!&ndash;                class="articles-list"&ndash;&gt; -->
      <!--            &lt;!&ndash;            >&ndash;&gt; -->
      <!--            &lt;!&ndash;              <div v-for="viewedArticle in viewedArticles" :key="viewedArticle.link"&ndash;&gt; -->
      <!--            &lt;!&ndash;                   class="articles-list-item mb16">&ndash;&gt; -->
      <!--            &lt;!&ndash;                <nuxt-link&ndash;&gt; -->
      <!--            &lt;!&ndash;                    :to="localePath(`/blog/${viewedArticle?.category?.link}/${viewedArticle?.link}`)"&ndash;&gt; -->
      <!--            &lt;!&ndash;                    class="articles-list-item-link"></nuxt-link>&ndash;&gt; -->
      <!--            &lt;!&ndash;                <p :style="{color: viewedArticle?.category?.color}"&ndash;&gt; -->
      <!--            &lt;!&ndash;                   class="category colored-title f14 mb0">&ndash;&gt; -->
      <!--            &lt;!&ndash;                  {{ viewedArticle?.category?.title }}&ndash;&gt; -->
      <!--            &lt;!&ndash;                </p>&ndash;&gt; -->
      <!--            &lt;!&ndash;                <p class="title-h3">&ndash;&gt; -->
      <!--            &lt;!&ndash;                  {{ viewedArticle?.title }}&ndash;&gt; -->
      <!--            &lt;!&ndash;                </p>&ndash;&gt; -->
      <!--            &lt;!&ndash;                <div class="f mta">&ndash;&gt; -->
      <!--            &lt;!&ndash;                  <div v-tooltip="viewedArticle?.author?.persona_name">&ndash;&gt; -->
      <!--            &lt;!&ndash;                    <img&ndash;&gt; -->
      <!--            &lt;!&ndash;                        :src="getImageFromProxy(viewedArticle?.author?.avatar_url || '', '30:30')"&ndash;&gt; -->
      <!--            &lt;!&ndash;                        alt="moderator avatar"&ndash;&gt; -->
      <!--            &lt;!&ndash;                        class="avatar"&ndash;&gt; -->
      <!--            &lt;!&ndash;                    >&ndash;&gt; -->
      <!--            &lt;!&ndash;                  </div>&ndash;&gt; -->
      <!--            &lt;!&ndash;                  <span class="f14">&ndash;&gt; -->
      <!--            &lt;!&ndash;                    {{ $t('read_time', {time: viewedArticle?.read_time}) }}&ndash;&gt; -->
      <!--            &lt;!&ndash;                  </span>&ndash;&gt; -->
      <!--            &lt;!&ndash;                </div>&ndash;&gt; -->
      <!--            &lt;!&ndash;              </div>&ndash;&gt; -->
      <!--            &lt;!&ndash;            </div>&ndash;&gt; -->
      <!--          </div> -->
      <!--        </aside> -->
      <!--      </div> -->
      <!--      <div class="blog-wrapper-small"> -->
      <!--        <PagesBlogQuestionsSection /> -->
      <!--      </div> -->

      <PagesBlogCategorizedArticles
        :category="(currentCategory || {}) as BlogCategory"
      />
    </div>
  </main>
</template>

<script lang="ts" setup>
import type { BlogCategory } from '~/graphql/generated/schema-types';
import { useRuntimeConfig } from '#app';
import moment from 'moment/moment';
import { useAlternateLinks } from '~/composables/alternate-links';
import { useStore } from '~/store';
import { useBlogStore } from '~/store/blog';
import { languagesEnum } from '~/types/LocalesToCockies';
import { setBlogViewed } from '~/utils/api';

definePageMeta({
  layout: 'no-categories',
});

const { locale, t } = useI18n();
const route = useRoute();
const store = useBlogStore();
const globalStore = useStore();
const localePath = useLocalePath();
moment.locale(locale.value);
const config = useRuntimeConfig();
const siteHost = config.public.siteHost;

const {
  data: article,
  error,
} = await useAsyncData(
  `getBlogPost-${useRoute().params.link}`,
  () => getBlogPost(route.params.link as string, languagesEnum[locale.value.toUpperCase() as keyof typeof languagesEnum]),
);

if (error.value || article.value?.errors?.length) {
  throw createError({ status: 404, statusText: error.value?.message || 'Not found' });
}

if (!store.categories?.length) {
  const {
    data: categories,
    error,
  } = await useAsyncData(`blogCategories`, () => getBlogCategories(), {
    transform: input => input?.data?.getBlogCategories,
  });
  if (error.value) {
    console.log(`Blog page categories fetch error: ${error.value?.message}` || 'Not found');
    // throw createError({status: 404})
  }

  store.categories = categories.value || [];
}

// @ts-ignore
// const { error: latestArticlesError }: {
//   data: BlogPost[] | null
//   error: any
// } = await useAsyncData(
//   `getBlogPostLatest-${useRoute().params.link}`,
//   () => getBlogPosts({
//     hidden: false,
//     page: 1,
//     limit: 3,
//     lang: locale.value,
//   }),
//   {
//     transform: input => input?.data?.getBlogPosts?.data,
//   },
// );
// if (latestArticlesError.value) {
//   console.log(`Latest articles error`, latestArticlesError.value);
// }

// @ts-ignore
// const { error: viewedArticlesError }: {
//   data: BlogPost[] | null
//   error: any
// } = await useAsyncData(
//   `getBlogPostViewed-${useRoute().params.link}`,
//   () => getBlogPosts({
//     hidden: false,
//     viewed: true,
//     page: 1,
//     limit: 3,
//     lang: locale.value,
//   }),
//   {
//     transform: input => input?.data?.getBlogPosts?.data,
//   },
// );
// if (viewedArticlesError.value) {
//   console.log(`Viewed articles error`, viewedArticlesError.value);
// }

onMounted(() => {
  if (!article?.value?.data?.getBlogPost?.viewed) {
    setBlogViewed(article.value?.data?.getBlogPost?.link || '');
  }
});

const content = computed(() => {
  let c = article.value?.data?.getBlogPost?.content || '';
  // Исключаем обработку тегов <script>
  // c = isMounted.value ? c : c.replace(/<script[^>]*>[\s\S]*?<\/script>/gi, '');

  // Удаление атрибутов rel и установка rel="follow", а также удаление /factory-new, /minimal-wear и т.д. из ссылки
  c = c.replace(/<a\b([^>]*)>/g, (match, attributes) => {
    const hrefMatch = attributes.match(/href="(https:\/\/csmarketcap\.com[^"]*)"/);
    if (hrefMatch) {
      let href = hrefMatch[1];
      href = href.replace(/\/(?:factory-new|minimal-wear|field-tested|well-worn|battle-scarred)$/, '');
      const updatedAttributes = attributes
        .replace(/href="[^"]+"/, `href="${href}"`)
        .replace(/\s*rel="[^"]*"/, '');
      return `<a${updatedAttributes} rel="follow">`;
    }
    return match;
  });

  // Замена изображений с добавлением lazy loading и прокси
  c = c.replace(/<img\s+src="(https?:\/\/cdn\.csmarketcap\.com\/uploads\/[^"]+)"/g, (match, src) => {
    return match.replace(src, getImageFromProxy(src, '1200:1000')).replace('<img', '<img loading="lazy" alt=""');
  });

  return c;
});

function likePost(liked: boolean) {
  (article.value || {} as any).data.getBlogPost = {
    ...(article.value || {} as any)?.data.getBlogPost,
    liked,
    likes_count: liked ? +((article.value || {} as any).data?.getBlogPost?.likes_count || 0) + 1 : +((article.value || {} as any).data?.getBlogPost?.likes_count || 0) - 1,
  };
}

const currentCategory = computed(() => {
  return store.categories.find(category => category.link === route.params.category) || {} as BlogCategory;
});

const breadcrumbs = computed(() => {
  return [
    { title: t('blog'), link: localePath('/blog') },
    {
      title: currentCategory.value.title || '',
      link: localePath(`/blog/${currentCategory.value.link}`),
    },
    {
      title: article?.value?.data?.getBlogPost?.title || '',
      link: article?.value?.data?.getBlogPost?.link || '',
    },
  ];
});

const {
  alternateLinks,
} = useAlternateLinks(`/blog/${article?.value?.data?.getBlogPost?.category?.link}/${article?.value?.data?.getBlogPost?.link}`);
const canonical = `${siteHost}/blog/${article?.value?.data?.getBlogPost?.category?.link}/${article?.value?.data?.getBlogPost?.link}`;
const langIcluded = article.value?.data?.getBlogPost?.langs?.includes(
  languagesEnum[locale.value.toUpperCase() as keyof typeof languagesEnum],
);

useHead({
  meta: [
    {
      name: 'keywords',
      content: article?.value?.data?.getBlogPost?.tags || 'steam, counter strike global offensive, csgo, cs2, skins, items, blog, posts',
    },
  ],
  link: [
    ...alternateLinks.value.filter(i =>
      i.rel !== 'canonical' && (i.hreflang === 'x-default' || article.value?.data?.getBlogPost?.langs?.includes(
        languagesEnum[i.hreflang?.toUpperCase() as keyof typeof languagesEnum],
      )),
    ),
    {
      rel: 'canonical',
      href: canonical,
    },
    {
      rel: 'amphtml',
      href: `${siteHost}${
        langIcluded ? locale.value === 'en' ? '' : `/${locale.value}` : ''
      }/amp/blog/${article?.value?.data?.getBlogPost?.category?.link}/${article?.value?.data?.getBlogPost?.link}`,
    },
  ],
});

useSeoMeta({
  title: () => article?.value?.data?.getBlogPost?.title || '',
  ogTitle: () => article?.value?.data?.getBlogPost?.title,
  description: () => article?.value?.data?.getBlogPost?.description,
  ogDescription: () => article?.value?.data?.getBlogPost?.description,
  ogImage: () => getImageFromProxy(article?.value?.data?.getBlogPost?.img?.replace('http:', 'https:') || '', '1200:630'),
  twitterCard: 'summary_large_image',
  twitterTitle: () => article?.value?.data?.getBlogPost?.title,
  twitterDescription: () => article?.value?.data?.getBlogPost?.description,
  twitterImage: () => getImageFromProxy(article?.value?.data?.getBlogPost?.img?.replace('http:', 'https:') || '', '1200:630'),
  ogSiteName: 'CSMarketCap',
  ogUrl: () => canonical,
  ogType: 'website',
  ogLocale: () => locale.value,
});

useSchemaOrg([
  defineArticle({
    '@type': 'NewsArticle',
    'headline': article?.value?.data?.getBlogPost?.title,
    'description': article?.value?.data?.getBlogPost?.description,
    'image': () => getImageFromProxy(article?.value?.data?.getBlogPost?.img?.replace('http:', 'https:') || '', '1200:630'), // URL изображения статьи
    'datePublished': article?.value?.data?.getBlogPost?.published_at,
    'dateModified': article?.value?.data?.getBlogPost?.updated_at, // Дата изменения статьи, если есть
    'timeRequired': article?.value?.data?.getBlogPost?.read_time, // Время на чтение, можно вычислить на основе текста
    'author': {
      '@type': 'Person',
      'name': article?.value?.data?.getBlogPost?.author?.persona_name || '',
      'url': `https://steamcommunity.com/profiles/${article?.value?.data?.getBlogPost?.author?.steamid64}`,
    },
    'publisher': {
      '@type': 'Organization',
      'name': 'CS Market Cap',
      'logo': {
        '@type': 'ImageObject',
        'url': '/img/logo-bg-black.png',
      },
    },
    'mainEntityOfPage': {
      '@type': 'WebPage',
      '@id': canonical,
    },
    'url': canonical,
  }),
  defineBreadcrumb({
    itemListElement: [
      { name: t('main'), item: '/' },
      { name: t('blog'), item: localePath('/blog') },
      { name: article?.value?.data?.getBlogPost?.title, item: route.path },
    ],
  }),
]);
</script>

<style lang="scss" scoped>
@use '/assets/scss/ui/blog.scss';

.blog-page {
  .wrapper {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 30px;
  }

  h2 {
    margin-bottom: 32px;
  }

  h3 {
    margin-bottom: 20px;
  }

  .top {
    color: var(--accent-on-primary);
    background: var(--accent-primary);
    border-radius: 10rem;
    white-space: nowrap;
    font-size: 14px;
    font-weight: 600;
    padding: 6px 8px;
  }

  .blog-wrapper {
    &-small {
      margin-right: auto;
      margin-left: 0;
    }
  }

  .flex-wrap {
    flex-wrap: wrap;
    gap: 16px;
  }

  .read-info {
    justify-content: flex-start;
    margin-bottom: 24px;

    svg {
      width: 16px;
      height: 16px;
      margin-right: 8px;
    }
  }

  .content {
    &, * {
      hyphens: auto;
      word-break: break-word;
    }

    :deep(h2),
    h2 {
      margin-bottom: 32px;
    }

    :deep(h3), h3 {
      margin-bottom: 20px;
    }

    :deep(ul), ul, :deep(ol), ol {
      p {
        margin-bottom: 0;
      }

      margin-bottom: 32px;
    }

    :deep(a), a {
      color: var(--accent-secondary);
      text-decoration: underline;
    }

    :deep(blockquote),
    blockquote {
      border-left: 4px solid var(--accent-primary);
      margin: 1.5em 10px;
      padding: 0.5em 10px;
      font-style: italic;

      p, h2, h3, span, a {
        margin-bottom: 0;
      }
    }

    :deep(img), img {
      width: 100%;
      height: 500px;
      object-fit: cover;
      border-radius: 12px;
      margin-bottom: 24px;
      @media screen and (max-width: 768px) {
        height: 300px;
      }
      @media screen and (max-width: 525px) {
        height: 230px;
      }
      @media screen and (max-width: 435px) {
        height: 170px;
      }
    }

    :deep(p), p {
      font-size: 18px;
      margin-bottom: 24px;
      line-height: 2;
    }

    :deep(.tableWrapper),
    .tableWrapper {
      width: 100%;
      overflow-x: auto;
      margin-bottom: 20px;
    }

    :deep(table), table {
      width: 100%;
      border-collapse: collapse;
      border-radius: 12px;

      p {
        margin-bottom: 0;
      }

      tr {
        th {
          cursor: pointer;
          color: var(--accent-on-accent-secondary);
          font-weight: 700;
          font-size: 14px;
          padding: 12px;
          background: var(--surfaces-low-container);
          border: 2px solid var(--accent-on-primary);
          white-space: nowrap;

          .th-wrapper {
            display: inline-flex;
            align-items: center;
            gap: 6px;
          }

          svg {
            width: 18px;
            height: 18px;
          }
        }
      }

      tbody {
        background: var(--surfaces-container);

        tr {
          border-collapse: collapse;

          &:hover {
            background: var(--surfaces-high-container);
          }

          td {
            border: 2px solid var(--accent-on-primary);
            padding: 12px;
            color: var(--accent-on-accent-secondary);
            text-align: center;

            &.title-td {
              max-width: 350px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }

            &.image-td {
              padding: 2px 5px;
              vertical-align: center;
              text-align: center;

              img {
                object-fit: contain;
                object-position: center;
                width: 100px;
                height: 50px;
              }
            }
          }
        }
      }
    }

    .author {
      &-image {
        width: 60px;
        height: 60px;
        object-fit: cover;
        border-radius: 50%;
        margin-right: 20px;
        margin-bottom: 0;
      }

      p {
        line-height: 1.2;
        margin-bottom: 8px;
      }
    }
  }

  .main-img {
    margin-bottom: 40px;
    width: 100%;
    max-height: 500px;
    border-radius: 12px;
    object-fit: cover;
  }

  .blog-sidebar {
    position: sticky;
    top: 100px;
    margin-bottom: 130px;
    flex-shrink: 0;
    min-width: 270px;
    width: 30%;
  }

  @media screen and (max-width: 979px) {
    .wrapper {
      flex-direction: column;
    }

    .blog-wrapper {
      &-small {
        margin-right: 0;
        max-width: unset;
      }
    }

    .main-img {
      margin-bottom: 20px;
    }
    .blog-sidebar {
      position: static;
      margin-bottom: 40px;
      width: 100%;

      .like-and-share {
        display: none;
      }
    }
  }
}
</style>
